<template>
  <span class="md-error">{{error}}</span>
</template>

<script>
  export default {
    props: {
      error: {
        type   : String,
        default: null,
      },
    },
  }
</script>

<style lang="scss">
</style>
